import catalogModule from '../catalogModule';

function catalogContentController($log, $scope) {
  'ngInject';

  $scope.isInitializedPage = () => {
    const { initialized, isPhone, isApp } = $scope.library;
    return initialized && !(isPhone && isApp);
  };
}

catalogModule.controller('catalogContentController', catalogContentController);

export default catalogContentController;
